export const FEEDBACK_STATE = {
  PENDING: 'pending',
  COMPLETED: 'completed',
}
